import { useIntl } from 'react-intl';
import * as Styled from './LoginPage.styled';
import { ExternalLoginPanel } from './ExternalLoginPanel';

interface SamlLoginPanelProps {
  readonly returnTo?: string;
  readonly samlDescription: string;
}

export const SamlLoginPanel = ({ returnTo, samlDescription }: SamlLoginPanelProps) => {
  const intl = useIntl();
  const href = returnTo ? `/samlc/login?returnTo=${returnTo}` : '/samlc/login';

  return (
    <ExternalLoginPanel panelId="organisationLogin" description={samlDescription}>
      <Styled.LoginLink href={href}>{intl.formatMessage({ id: 'signIn', defaultMessage: 'Sign in' })}</Styled.LoginLink>
    </ExternalLoginPanel>
  );
};
